module.exports = __webpack_public_path__ + "img/logo-ams.5fee8077.svg";